import { EntidadConciliableReadingDtoProps } from "api/DTOs/EntidadConciliableReadingDto"

export const entidadConciliableReadingDtoAdapter = (
  item: EntidadConciliableReadingDtoProps
): EntidadConciliableReadingDtoProps => ({
  id: item?.id,
  asientoContable: item?.asientoContable,
  descripcion: item?.descripcion,
  empresa: item?.empresa,
  fecha: item?.fecha,
  identificador: item?.identificador,
  importe: item?.importe,
  tipo: item?.tipo,
})
